export default {
  SEARCH_CATALOG_KUSPIT_STATE_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_STATE_QUERY'),
  CATALOG_KUSPIT_STATE_REPOSITORY: Symbol.for('CATALOG_KUSPIT_STATE_REPOSITORY'),
  CATALOG_KUSPIT_STATE_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_STATE_STATE_MANAGER'),
};
